
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ExpertiseSection from './components/ExpertiseSection';
import ServicesSection from './components/ServicesSection';
import SegmentsSection from './components/SegmentsSection';
import DifferentiatorSection from './components/DifferentiatorSection';
import TeamSection from './components/TeamSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <ExpertiseSection />
        <ServicesSection />
        <SegmentsSection />
        <DifferentiatorSection />
        <TeamSection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
